import { render, staticRenderFns } from "./loader-item.vue?vue&type=template&id=444e4a3e"
import script from "./loader-item.vue?vue&type=script&lang=js"
export * from "./loader-item.vue?vue&type=script&lang=js"
import style0 from "./loader-item.vue?vue&type=style&index=0&id=444e4a3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports